import { useState, useEffect } from 'react'
import { adminService } from 'core/services/adminService'
import { toast } from 'react-toastify'

import c from './assets/sass/trigger-edit.module.scss'

export const TriggerEdit = ({ configId, onBack }) => {
    const [config, setConfig] = useState(null)
    const [messages, setMessages] = useState([])
    const [loading, setLoading] = useState(true)
    const [settings, setSettings] = useState({})

    useEffect(() => {
        loadData()
    }, [configId])

    const loadData = async () => {
        try {
            const data = await adminService.getTriggerConfig(configId)
            setConfig(data.config)
            setMessages(data.messages || [])
            setSettings({
                priority: data.config.priority,
                cooldownHours: data.config.cooldownHours,
                maxSendsTotal: data.config.maxSendsTotal,
                initialDelayMinutes: data.config.initialDelayMinutes || 0,
            })
        } catch (error) {
            toast('Ошибка загрузки', { type: 'error' })
        } finally {
            setLoading(false)
        }
    }

    const handleSaveSettings = async () => {
        try {
            await adminService.updateTriggerConfig(configId, {
                ...settings,
                initialDelayMinutes: settings.initialDelayMinutes || 0,
            })
            toast('Настройки сохранены', { type: 'success' })
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        }
    }

    const handleSaveMessage = async (msg) => {
        try {
            await adminService.updateTriggerMessage(msg.id, {
                text: msg.text,
                buttonText: msg.buttonText,
                buttonUrl: msg.buttonUrl,
                imageUrl: msg.imageUrl || null,
                orderIndex: msg.orderIndex,
                isActive: msg.isActive,
            })
            toast('Сообщение сохранено', { type: 'success' })
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        }
    }

    const handleDeleteMessage = async (messageId) => {
        if (!window.confirm('Удалить это сообщение?')) return
        try {
            await adminService.deleteTriggerMessage(messageId)
            setMessages(messages.filter(m => m.id !== messageId))
            toast('Сообщение удалено', { type: 'success' })
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        }
    }

    const handleAddMessage = async () => {
        try {
            const result = await adminService.createTriggerMessage(configId, {
                text: 'Новое сообщение',
                buttonText: 'Открыть',
                buttonUrl: 'https://t.me/gg_funny_bot?startapp',
                orderIndex: messages.length,
            })
            setMessages([...messages, result.message])
            toast('Сообщение добавлено', { type: 'success' })
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        }
    }

    const updateMsg = (index, field, value) => {
        const updated = [...messages]
        updated[index] = { ...updated[index], [field]: value }
        setMessages(updated)
    }

    if (loading) return <div style={{ color: 'white', textAlign: 'center', padding: '40px' }}>Загрузка...</div>
    if (!config) return null

    return (
        <div className={c.component}>
            <button className={c.backBtn} onClick={onBack}>← Назад к списку</button>

            <div className={c.section}>
                <div className={c.sectionTitle}>Настройки триггера: {config.type}</div>
                <div className={c.settingsGrid}>
                    <div className={c.field}>
                        <label>Приоритет</label>
                        <input
                            type="number"
                            value={settings.priority || ''}
                            onChange={e => setSettings({ ...settings, priority: parseInt(e.target.value) || 1 })}
                            min={1} max={10}
                        />
                    </div>
                    <div className={c.field}>
                        <label>Cooldown (часы)</label>
                        <input
                            type="number"
                            value={settings.cooldownHours || ''}
                            onChange={e => setSettings({ ...settings, cooldownHours: parseInt(e.target.value) || 1 })}
                            min={1}
                        />
                    </div>
                    <div className={c.field}>
                        <label>Макс отправок (0=∞)</label>
                        <input
                            type="number"
                            value={settings.maxSendsTotal ?? ''}
                            onChange={e => setSettings({ ...settings, maxSendsTotal: parseInt(e.target.value) || 0 })}
                            min={0}
                        />
                    </div>
                    {settings.initialDelayMinutes !== undefined && (
                        <div className={c.field}>
                            <label>Задержка 1-го (мин)</label>
                            <input
                                type="number"
                                value={settings.initialDelayMinutes ?? 0}
                                onChange={e => setSettings({ ...settings, initialDelayMinutes: parseInt(e.target.value) || 0 })}
                                min={0}
                            />
                        </div>
                    )}
                </div>
                <button className={c.saveSettingsBtn} onClick={handleSaveSettings}>
                    Сохранить настройки
                </button>
            </div>

            <div className={c.section}>
                <div className={c.sectionTitle}>Сообщения ({messages.length})</div>

                {messages.map((msg, i) => (
                    <div key={msg.id} className={c.messageCard}>
                        <div className={c.messageHeader}>
                            <span className={c.messageOrder}>
                                #{msg.orderIndex} {!msg.isActive && '(выключено)'}
                            </span>
                            <div className={c.messageActions}>
                                <button
                                    className={c.saveBtn}
                                    onClick={() => handleSaveMessage(msg)}
                                >
                                    Сохранить
                                </button>
                                <button
                                    className={c.toggleBtn}
                                    onClick={() => {
                                        updateMsg(i, 'isActive', !msg.isActive)
                                        handleSaveMessage({ ...msg, isActive: !msg.isActive })
                                    }}
                                >
                                    {msg.isActive ? 'Выкл' : 'Вкл'}
                                </button>
                                <button
                                    className={c.deleteBtn}
                                    onClick={() => handleDeleteMessage(msg.id)}
                                >
                                    Удалить
                                </button>
                            </div>
                        </div>

                        <div className={c.field}>
                            <label>Текст</label>
                            <textarea
                                value={msg.text}
                                onChange={e => {
                                    updateMsg(i, 'text', e.target.value)
                                    e.target.style.height = 'auto'
                                    e.target.style.height = e.target.scrollHeight + 'px'
                                }}
                                onFocus={e => {
                                    e.target.style.height = 'auto'
                                    e.target.style.height = e.target.scrollHeight + 'px'
                                }}
                                rows={6}
                            />
                        </div>

                        <div className={c.settingsGrid}>
                            <div className={c.field}>
                                <label>Текст кнопки</label>
                                <input
                                    type="text"
                                    value={msg.buttonText}
                                    onChange={e => updateMsg(i, 'buttonText', e.target.value)}
                                />
                            </div>
                            <div className={c.field}>
                                <label>URL кнопки</label>
                                <input
                                    type="text"
                                    value={msg.buttonUrl}
                                    onChange={e => updateMsg(i, 'buttonUrl', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className={c.bottomRow}>
                            <div className={c.field}>
                                <label>URL картинки</label>
                                <input
                                    type="text"
                                    value={msg.imageUrl || ''}
                                    onChange={e => updateMsg(i, 'imageUrl', e.target.value)}
                                    placeholder="https://example.com/image.jpg"
                                />
                            </div>
                            <div className={c.field} style={{ maxWidth: 80 }}>
                                <label>Порядок</label>
                                <input
                                    type="number"
                                    value={msg.orderIndex}
                                    onChange={e => updateMsg(i, 'orderIndex', parseInt(e.target.value) || 0)}
                                    min={0}
                                />
                            </div>
                        </div>
                        {msg.imageUrl && (
                            <div className={c.imagePreview}>
                                <img src={msg.imageUrl} alt="preview" onError={e => e.target.style.display = 'none'} />
                            </div>
                        )}
                    </div>
                ))}

                <button className={c.addMessageBtn} onClick={handleAddMessage}>
                    + Добавить сообщение
                </button>
            </div>
        </div>
    )
}
